import React, { useState } from "react";
import PageTitle from "../../../shared/PageTitle";
import { useEffect } from "react";
import { ActionTypes } from "../../../redux/ActionTypes";
import { APPLICATION_PDF, BASE64, BlankString, MenuId } from "../../../Constants";
import { useDispatch } from "react-redux";
import Button from '@mui/material/Button';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import PdfViewer from "../../../shared/PdfViewer";
import { formsData, documentData } from "../../../data/Forms&Documents";

export default function FormsAndDocuments() {
  const dispatch = useDispatch();
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [scroll, setScroll] = React.useState<DialogProps["scroll"]>("paper");
  const [base64pdfData, setbase64PdfData] = useState<string>(BlankString);
  const ifameSource = `data:${APPLICATION_PDF};${BASE64},${BlankString}`;
  const [modalTile, setModalTitle] = useState<string>("PDF Viewer");
  const [formSearchText, setFormSearchText] = useState<string>(BlankString);
  const [docSearchText, setDocSearchText] = useState<string>(BlankString);
  const [forms, setForms] = useState(formsData);
  const [initialForms] = useState(formsData);
  const [docs, setDocs] = useState(documentData);
  const [initialDocs] = useState(documentData);
  const [url, setUrl] = useState<string>(BlankString);
  const [fileName, setFileName] = useState<string>(BlankString);
  useEffect(() => {
    dispatch({ type: ActionTypes.SET_ACTIVE_LINK, payload: MenuId.RESOURCES });
    dispatch({ type: ActionTypes.SET_FIRST_LEVEL_ACTIVE_MENU, payload: MenuId.FORMS_AND_DOCS });
  }, [forms]);

  const OpenDialog = (form: any) => {
    setbase64PdfData(BlankString);
    setModalTitle(form.name);
    setShowDialog(!showDialog);
    setFileName(form.fileName);
    setUrl(encodeURI(URL.createObjectURL(base64toBlob(form.data))));
  };

  const CloseDialog = () => {
    setShowDialog(false);
  };

  const base64toBlob = (data: string) => {
    const bytes: string = window.atob(data);
    let length = bytes.length;
    let out = new Uint8Array(length);
    while (length--) {
      out[length] = bytes.charCodeAt(length);
    }
    return new Blob([out], { type: APPLICATION_PDF });
  };

  const handleSearchText = (event: any) => {
    const searchString = event.target.value;
    if (event.target.name === "form_search") {
      setFormSearchText(event.target.value);
      const filteredForms = initialForms.filter((form) => {
        if (form.name.toLowerCase().includes(searchString.toLowerCase()) || form.description.toLowerCase().includes(searchString.toLowerCase())) {
          return form;
        }
      });
      if (searchString)
        setForms(filteredForms);
      else
        setForms(initialForms);
    }

    if (event.target.name === "doc_search") {
      setDocSearchText(event.target.value);
      const filteredDocs = initialDocs.filter((doc) => {
        if (doc.name.toLowerCase().includes(searchString.toLowerCase()) || doc.description.toLowerCase().includes(searchString.toLowerCase())) {
          return doc;
        }
      });
      if (searchString)
        setDocs(filteredDocs);
      else
        setDocs(initialDocs);
    }

  };

  const ModalDialog = (props: any) => {
    return (
      <div>
        <Dialog
          scroll={props.scroll}
          fullWidth
          maxWidth='md'
          open={props.show}
          onClose={props.onClose}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          PaperProps={{ sx: { height: 700 } }}>
          <DialogTitle id="scroll-dialog-title">
            {props.title}
          </DialogTitle>
          <DialogContent dividers={props.scroll === "paper"} style={{ padding: 0 }}>
            <PdfViewer url={props.fileUrl} fileName={fileName} />
          </DialogContent>
          <DialogActions>
            <Button onClick={props.onClose}>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  return (
    <>
      <PageTitle title="Forms & Documents" />
      <ModalDialog show={showDialog} onClose={CloseDialog} scroll={scroll} title={modalTile} fileUrl={url} />
      <div className="container gp-container">
        <div className="row">
          <div className="col-md-4">
            <div className="has-feedback has-search">
              <span className="form-control-feedback"><i className="fa fa-search" aria-hidden="true"></i></span>
              <input type="text" name="form_search" className="form-control" placeholder="Search Forms" value={formSearchText} onChange={handleSearchText} />
            </div>
          </div>
        </div>
        <div className="row">
          {
            forms.map((form) => {
              return (
                <div className="col-md-4" style={{ marginTop: 10 }} key={form.name}>
                  <div className="resource-form" style={{ height: 100, border: "solid 1px #f2f1f0", borderRadius: 5, cursor: "pointer" }} onClick={() => { OpenDialog(form) }}>
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <img src={`${process.env.PUBLIC_URL}/images/pdf.png`} height={75} width={60} />
                          </td>
                          <td valign="top" style={{ verticalAlign: "middle", paddingLeft: 10, fontSize: 13, paddingRight: 5 }}>
                            <div style={{ fontWeight: "bolder", fontSize: 15, color: "#000" }}>{form.name}</div>
                            <div><p style={{ fontSize: 12, lineHeight: 1.5 }}>{form.description}</p></div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })
          }
        </div>
        <div className="row" style={{ marginTop: 35 }}>
          <div className="col-md-4">
            <div className="has-feedback has-search">
              <span className="form-control-feedback"><i className="fa fa-search" aria-hidden="true"></i></span>
              <input type="text" name="doc_search" className="form-control" placeholder="Search Documents" value={docSearchText} onChange={handleSearchText} />
            </div>
          </div>
        </div>
        <div className="row">
          {
            docs.map((doc) => {
              return (
                <div className="col-md-3" style={{ marginTop: 10 }} key={doc.name}>
                  <div className="resource-form" style={{ border: "solid 1px #aeaeae", borderRadius: 5, cursor: "pointer" }} onClick={() => { OpenDialog(doc) }}>
                    <div>
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            <td style={{ borderBottom: "solid 10px #d6d6d6", padding: 4 }}>
                              <img src={`${process.env.PUBLIC_URL}/images/${doc.thumb_nail}`} height={225} width={"100%"} />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div style={{ padding: 10, minHeight: 80 }}>
                        <div style={{ fontWeight: "bolder", fontSize: 15, color: "#000" }}>{doc.name}</div>
                        <div><p style={{ fontSize: 12, lineHeight: 1.5 }}>{doc.description}</p></div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    </>
  )
};